angular.module('app.usuarioService', [
  
])

.factory('usuarioService', ['$http', '$q', 'appSettings', function ( $http, $q, appSettings ) {

  return {
    getUsuariosSistema: function( data ) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getUsuariosSistema')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getDespachosUsuario: function(p_id_usuario,p_opcion) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/usuario/'+p_id_usuario+
                                                               '/opcion/'+p_opcion+'/getDespachosUsuario')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getPersonaUsuarioInterno: function(usuario) 
    {
        var deferred = $q.defer();
        $http.get(appSettings.restOAUTH + 'Login/'+usuario+'/getPersonaUsuarioInterno')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getCargo: function( data ) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getCargo')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getEstudio: function( data ) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getEstudio')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    insUsuario: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/insUsuario',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },

    delUsuario: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/delUsuario',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },

    insCentroUsuario: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/insCentroUsuario',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },

    delCentroUsuario: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/delCentroUsuario',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },

    edtCargoUsuario: function( data ) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Transacciones/edtCargoUsuario',data)
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    }
    /*getUsuariosActivos: function() 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Usuarios/getUsuariosActivos')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },
    getListadoUsuarios: function() 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Usuarios/getListadoUsuarios')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },
    getDelegaciones: function() 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Delegaciones/getDelegaciones')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },
    getDelegacionUsuario: function(p_id_usuario) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Delegaciones/'+p_id_usuario+'/getDelegacionUsuario')
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    asignarDelegacion: function(data) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Delegaciones/asignarDelegacion', data)
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    desactivarUsuario: function(data) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restOAUTH + 'Administracion/desactivarUsuario', data)
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    reactivarUsuario: function(data) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restOAUTH + 'Administracion/reactivarUsuario', data)
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },
    desactivarUsuarioCAPE: function(data) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Usuarios/desactivarUsuario', data)
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    },

    reactivarUsuarioCAPE: function(data) 
    {
        var deferred = $q.defer();
        $http.post( appSettings.restApiServiceBaseUri + 'Usuarios/reactivarUsuario', data)
        .then(successCallback, errorCallback);
            function successCallback(data)
            {
                deferred.resolve( data );
            }
            function errorCallback(error)
            {
                deferred.reject( error );
            }
        return deferred.promise;
    }*/
  }
                                                                                                   
}]);